import client from '../../../client'

export default {
  // 初期表示
  FirstDisplay: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/MasterWIGA1/MasterWIGA1FirstDisplay'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        jgcd: param.jgcd,
        jgnm: param.jgnm,
        cmnm: param.cmnm,
        ukno: param.ukno,
        nend: param.nend,
        ykdyStartYear: param.ykdyStartYear,
        ykdyStartMonth: param.ykdyStartMonth,
        ykdyStartDate: param.ykdyStartDate,
        ykdyEndYear: param.ykdyEndYear,
        ykdyEndMonth: param.ykdyEndMonth,
        ykdyEndDate: param.ykdyEndDate,
        crdtStartYear: param.crdtStartYear,
        crdtStartMonth: param.crdtStartMonth,
        crdtStartDate: param.crdtStartDate,
        crdtEndYear: param.crdtEndYear,
        crdtEndMonth: param.crdtEndMonth,
        crdtEndDate: param.crdtEndDate,
        updtStartYear: param.updtStartYear,
        updtStartMonth: param.updtStartMonth,
        updtStartDate: param.updtStartDate,
        updtEndYear: param.updtEndYear,
        updtEndMonth: param.updtEndMonth,
        updtEndDate: param.updtEndDate,
        hkkg: param.hkkg,
        trno: param.trno,
        waku: param.waku,
        opbr: param.opbr,
        opcd: param.opcd,
        ykst: param.ykst,
        ryak: param.ryak,
        name: param.name,
        csst: param.csst,
        tmzn: param.tmzn,
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      };

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
  // 検索
  Search: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/MasterWIGA1/MasterWIGA1Search'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        jgcd: param.jgcd,
        jgnm: param.jgnm,
        cmnm: param.cmnm,
        ukno: param.ukno,
        nend: param.nend,
        ykdyStartYear: param.ykdyStartYear,
        ykdyStartMonth: param.ykdyStartMonth,
        ykdyStartDate: param.ykdyStartDate,
        ykdyEndYear: param.ykdyEndYear,
        ykdyEndMonth: param.ykdyEndMonth,
        ykdyEndDate: param.ykdyEndDate,
        crdtStartYear: param.crdtStartYear,
        crdtStartMonth: param.crdtStartMonth,
        crdtStartDate: param.crdtStartDate,
        crdtEndYear: param.crdtEndYear,
        crdtEndMonth: param.crdtEndMonth,
        crdtEndDate: param.crdtEndDate,
        updtStartYear: param.updtStartYear,
        updtStartMonth: param.updtStartMonth,
        updtStartDate: param.updtStartDate,
        updtEndYear: param.updtEndYear,
        updtEndMonth: param.updtEndMonth,
        updtEndDate: param.updtEndDate,
        hkkg: param.hkkg,
        trno: param.trno,
        waku: param.waku,
        opbr: param.opbr,
        opcd: param.opcd,
        ykst: param.ykst,
        ryak: param.ryak,
        name: param.name,
        csst: param.csst,
        tmzn: param.tmzn,
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      };

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
  // ダウンロード
  CsvDownload: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/MasterWIGA1/MasterWIGA1CsvDownload'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        ptcd: param.ptcd,
        uknos: param.uknos
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      };

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/Admin/Master/WIGA1/WIGA1Api.js